import { styled } from 'styled-components';

export const StyledPrivacyPolicyLayout = styled.div`
    background-color: ${({ theme }) => theme.bgColors.white};

    & {
        .react-select__control {
            height: 48px;
            font-weight: 600;
        }

        .react-select__indicator-separator {
            display: none;
        }

        .image-wrapper {
            padding: 20px;

            & img {
                min-width: 50vw;
                height: calc(100vh - 40px);
                border-radius: 16px;
                transform: scaleX(-1);
            }
        }
    }

    .container {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        margin: auto;
    }

    .go-back-btn {
        margin-bottom: 90px;
        @media (max-width: 1200px) {
            margin-bottom: 30px;
        }
    }

    .form {
        max-width: 400px;
    }

    form {
        align-self: stretch;

        & > div:nth-child(even) {
            margin-top: 0px;
        }
    }

    .header {
        min-width: 400px;
        margin-top: 50px;
        align-self: flex-start;
        margin-bottom: 40px;

        & > a > svg {
            margin: 0;
        }
    }

    .link {
        font-size: 13px;
        font-weight: 500;
        line-height: 150%;
        margin-left: 12px;
        cursor: pointer;
    }
`;
